import React from "react";
import styled from "styled-components";
import type { LinearGradientProps } from "@xsolla/xui-primitives-core";

function buildCssGradient(
  colors: string[],
  start: { x: number; y: number },
  end: { x: number; y: number },
  locations?: number[]
): string {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const angle = Math.round((Math.atan2(dx, -dy) * 180) / Math.PI);

  const stops = colors
    .map((color, i) => {
      const pct = locations
        ? locations[i] * 100
        : (i / (colors.length - 1)) * 100;
      return `${color} ${pct}%`;
    })
    .join(", ");

  return `linear-gradient(${angle}deg, ${stops})`;
}

const StyledGradient = styled.div<{ $gradient: string }>`
  background: ${(props) => props.$gradient};
`;

export const LinearGradient: React.FC<LinearGradientProps> = ({
  colors,
  start = { x: 0, y: 0 },
  end = { x: 0, y: 1 },
  locations,
  children,
  position,
  top,
  bottom,
  left,
  right,
  width,
  height,
  borderRadius,
  overflow,
  zIndex,
  style,
  "data-testid": dataTestId,
}) => {
  const gradient = buildCssGradient(colors, start, end, locations);

  const containerStyle: React.CSSProperties = {
    position: position || undefined,
    top: typeof top === "number" ? `${top}px` : top,
    bottom: typeof bottom === "number" ? `${bottom}px` : bottom,
    left: typeof left === "number" ? `${left}px` : left,
    right: typeof right === "number" ? `${right}px` : right,
    width: typeof width === "number" ? `${width}px` : width,
    height: typeof height === "number" ? `${height}px` : height,
    borderRadius:
      typeof borderRadius === "number" ? `${borderRadius}px` : borderRadius,
    overflow,
    zIndex,
    ...style,
  };

  return (
    <StyledGradient
      $gradient={gradient}
      style={containerStyle}
      data-testid={dataTestId}
    >
      {children}
    </StyledGradient>
  );
};
